var content = (function (module) {
var css = { id: module.id, exports: {} };
(function (module) {
exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".buttonStyles {\n  text-align: center;\n  /* padding: 4px; */\n  cursor: pointer;\n  font-size: 16px;\n}\n.buttonStyles:hover {\n  color: #211c38;\n}\n", "",{"version":3,"sources":["popover.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,cAAc;AAChB","file":"popover.css","sourcesContent":[".buttonStyles {\n  text-align: center;\n  /* padding: 4px; */\n  cursor: pointer;\n  font-size: 16px;\n}\n.buttonStyles:hover {\n  color: #211c38;\n}\n"]}]);


})(css);
return css.exports;
}) (module);
var loader = require("/home/ubuntu/trooprbot-ui/node_modules/antd-theme/lib/loadThemedStyles.js");

if(typeof content === "string") content = [[module.id, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;